<template>
  <b-overlay :show="loading">
    <h5 class="mb-5">
      Verificación de identidad para el proveedor
      de firma: {{this.company.firmaAvanzada}}
    </h5>
    <b-card>
      <div class="d-flex justify-content-around">
        <img
          :src="stampUrl"
          alt="Estampa"
          class="mb-4"
          width="300px;"
        />
      </div>
      <verification-form
        :stampUrl="stampUrl"
        :cuUserData="cuUserData"
      />
    </b-card>
  </b-overlay>
</template>

<script>
import { mapGetters } from 'vuex';

import { cuVerificationInfo, signConfigStamp } from '@/febos/servicios/api/usuarios.api';
import VerificationForm
  from '@/febos/global/usuario/components/sign/advanced/eSign/components/VerificationForm';

export default {
  data() {
    return {
      cuUserData: {},
      loading: false,
      showQuestions: true,
      getCertificate: true,
      securityQuestions: {},
      stampUrl: ''
    };
  },
  components: { VerificationForm },
  computed: {
    ...mapGetters('Empresas', [
      'company'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ])
  },
  methods: {
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    async verifyInfoUser() {
      try {
        this.loading = true;
        const { idProceso } = this.$route.query;
        const response = await cuVerificationInfo({
          params: {
            tipo: this.company.firmaAvanzada,
            accion: 'info',
            debug: ''
          },
          body: {
            idProceso,
            rut: this.currentUser.iut
          }
        });
        const { info } = response.data;
        this.cuUserData = {
          iut: `${info.RolUnico.numero }-${ info.RolUnico.DV}`,
          name: info.name.nombres.join(' '),
          lastName: info.name.apellidos[0],
          mothersLastName: info.name.apellidos[1],
          address: '',
          iutNumber: '',
          email: '',
          landline: '',
          phone: '',
          civilStatus: '',
          birthday: ''
        };
        this.loading = false;
      } catch {
        this.loading = false;
      }
    },
    async getSignatureStamp() {
      try {
        this.loading = true;
        const response = await signConfigStamp({
          categoria: 'PREVISUALIZAR_FIRMA',
          idUsuarioFirma: this.currentUser.id,
          parametros: {
            accion: 'PREVISUALIZAR_FIRMA'
          },
          proveedor: this.company.firmaAvanzada,
          tipoFirma: 'firmaAvanzada'
        });
        this.stampUrl = response.data.parametros.estampa;
        this.loading = false;
      } catch {
        this.loading = false;
      }
    }
  },
  async created() {
    await this.verifyInfoUser();
    await this.getSignatureStamp();
  },
  props: {
    user: { type: Object },
    signConfiguration: { type: Object }
  },
};
</script>
